import type { PreQuestionResponse } from '@flex-apis/recruiting';

// TODO: web-pages의 도메인과 중복 제거
export interface CandidatePreQuestion {
  readonly idHash: string;
  readonly title: string;
  readonly isRequired: boolean;
  readonly expectedMaxContentLength: number;
  readonly displayOrder: number;
}

export function generateCandidatePreQuestion(
  res: PreQuestionResponse
): CandidatePreQuestion {
  return {
    idHash: res.preQuestionIdHash,
    title: res.title,
    isRequired: res.isRequired,
    expectedMaxContentLength: res.expectedMaxContentLength,
    displayOrder: res.displayOrder,
  };
}
